import React, { FC, useEffect, useState } from 'react';
import { Grid, IconButton, TextField } from '@mui/material';
import RecentActorsIcon from '@mui/icons-material/RecentActors';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import { useDebounce } from '../../../hooks/useDebounce';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import TableChartIcon from '@mui/icons-material/TableChart';
import { useSearcherStore } from '../../../hooks/useSearcherStore';

interface FiltersV3Props {
    setShowFilters: any;
    getFilterProducts: () => Promise<false | undefined>;
    viewType: any;
    setViewType: any;
}

const SearcherKFCFilterModal: FC<FiltersV3Props> = (props): JSX.Element | any => {
    const { setShowFilters, getFilterProducts, viewType, setViewType } = props;
    const { filterProducts, setFilterProducts } = useSearcherStore();
    const [loading, setLoading] = useState<boolean>(false);
    
    // Debounced values
    const debouncedFilterCode = useDebounce(filterProducts.code, 500);
    const debouncedCategory = useDebounce(filterProducts.category_name, 500);
    const debouncedSubcategory = useDebounce(filterProducts.subcategory_name, 500);
    const debouncedLine = useDebounce(filterProducts.line, 500);
    const debouncedMarca = useDebounce(filterProducts.marca, 500);
    const debouncedModelo = useDebounce(filterProducts.modelo, 500);

    useEffect(() => {
        onFilter();
    }, [debouncedFilterCode, debouncedCategory, debouncedSubcategory, debouncedLine, debouncedMarca, debouncedModelo]);

    const onFilter = async () => {
        setLoading(true);
        await getFilterProducts();
        setLoading(false);
    };

    return (
        <Grid container spacing={2} sx={{ backgroundColor: 'whitesmoke', padding: '16px', borderRadius: '15px', alignItems: 'center' }}>

            {/* Filtro por Código */}
            <Grid item xs={12} sm={6} md={2.5} lg={2.5} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <RecentActorsIcon sx={{ color: '#4A90E2', mr: 1 }} />
                <TextField
                    label="Código"
                    variant="outlined"
                    size='small'
                    fullWidth
                    value={filterProducts.code}
                    onChange={(e) => setFilterProducts({...filterProducts, code: e.target.value})}
                    sx={{ backgroundColor: 'white' }}
                />
            </Grid>

            {/* Filtro por Familia */}
            {/* <Grid item xs={12} sm={6} md={2.5} lg={2.5} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <CategoryIcon sx={{ color: '#4A90E2', mr: 1 }} />
                <TextField
                    label="Familia"
                    variant="outlined"
                    size='small'
                    fullWidth
                    value={filterProducts.category_name}
                    onChange={(e) => setFilterProducts({...filterProducts, category_name:e.target.value})}
                    sx={{ backgroundColor: 'white' }}
                />
            </Grid> */}

            {/* Filtro por Subfamilia */}
            {/* <Grid item xs={12} sm={6} md={2.5} lg={2.5} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <AccountTreeIcon sx={{ color: '#4A90E2', mr: 1 }} />
                <TextField
                    label="Subfamilia"
                    variant="outlined"
                    size='small'
                    fullWidth
                    value={filterProducts.subcategory_name}
                    onChange={(e) => setFilterProducts({...filterProducts, subcategory_name:e.target.value})}
                    sx={{ backgroundColor: 'white' }}
                />
            </Grid> */}

            {/* Filtro por MARCA */}
            <Grid item xs={12} sm={6} md={2.5} lg={2.5} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <CategoryIcon sx={{ color: '#4A90E2', mr: 1 }} />
                <TextField
                    label="Marca"
                    variant="outlined"
                    size='small'
                    fullWidth
                    value={filterProducts.marca}
                    onChange={(e) => setFilterProducts({...filterProducts, marca: e.target.value})}
                    sx={{ backgroundColor: 'white' }}
                />
            </Grid>

            {/* Filtro por MODELO */}
            <Grid item xs={12} sm={6} md={2.5} lg={2.5} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <AccountTreeIcon sx={{ color: '#4A90E2', mr: 1 }} />
                <TextField
                    label="Modelo"
                    variant="outlined"
                    size='small'
                    fullWidth
                    value={filterProducts.modelo}
                    onChange={(e) => setFilterProducts({...filterProducts, modelo: e.target.value})}
                    sx={{ backgroundColor: 'white' }}
                />
            </Grid>

            {/* Filtro por Línea */}
            <Grid item xs={12} sm={6} md={2.5} lg={2.5} xl={2.5} sx={{ display: 'flex', alignItems: 'center' }}>
                <AccountTreeIcon sx={{ color: '#4A90E2', mr: 1 }} />
                <TextField
                    label="Línea"
                    variant="outlined"
                    size='small'
                    fullWidth
                    value={filterProducts.line}
                    onChange={(e) => setFilterProducts({...filterProducts, line: e.target.value})}
                    sx={{ backgroundColor: 'white' }}
                />
            </Grid>

            <Grid item xs={12} sm={6} md={2} lg={2} xl={2} sx={{ display: 'flex', alignItems: 'center' }}>
            <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', gap: '10px' }}>
                {/* Icono para cambiar a vista de cards */}
                <IconButton
                    onClick={() => setViewType('cards')}
                    sx={{
                        backgroundColor: viewType === 'cards' ? '#EBA058' : '#ffffff',
                        '&:hover': { backgroundColor: '#d9924e' },
                        borderRadius: '10px',
                        padding: '8px',
                        boxShadow: viewType === 'cards' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'
                    }}
                >
                    <ViewModuleIcon sx={{ color: viewType === 'cards' ? '#fff' : '#000', fontSize: 30 }} />
                </IconButton>

                {/* Icono para cambiar a vista de tabla */}
                <IconButton
                    onClick={() => setViewType('table')}
                    sx={{
                        backgroundColor: viewType === 'table' ? '#EBA058' : '#ffffff',
                        '&:hover': { backgroundColor: '#d9924e' },
                        borderRadius: '10px',
                        padding: '8px',
                        boxShadow: viewType === 'table' ? '0 4px 8px rgba(0, 0, 0, 0.1)' : 'none'
                    }}
                >
                    <TableChartIcon sx={{ color: viewType === 'table' ? '#fff' : '#000', fontSize: 30 }} />
                </IconButton>
            </Grid>
            </Grid>

            

            {/* Botón de Aplicar Filtros */}
            {/* <Grid item xs={12} sm={12} md={2} lg={2} xl={2} sx={{ display: 'flex', justifyContent: 'center' }}>
                <Button
                    variant="contained"
                    sx={{
                        backgroundColor: '#EBA058',  // Color acorde a los botones de los cards
                        '&:hover': { backgroundColor: '#d9924e' },  // Color más oscuro en hover
                    }}
                    onClick={onFilter}
                    disabled={loading}
                >
                    {loading ? <CircularProgress size={24} /> : 'Aplicar'}
                </Button>
            </Grid> */}
        </Grid>
    );
};

export default SearcherKFCFilterModal;
